export default __webpack_public_path__ + "static/media/long_to_do_list_cartoon.7b43c978.jpg";